<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle :title="$route.meta.title"></PageTitle>
        <b-card>
          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <button class="btn btn-success float-right mr-3 padder"
                        type="button" @click="update"
                >{{ $t('page.generic.update') }}
                </button>
                <router-link class="btn btn-primary float-right" role="button" :to="{name: 'jasperListRoute'}">
                  {{$t('actions.abort')}}
                </router-link>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label>Jasper URI</label>
                <b-form-input type="text" id="uri" v-model="jasper.uri" disabled
                              :value="jasper.uri"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="filename">Filename <required-field /></label>
                <b-form-input type="text" id="filename" v-model="jasper.filename" disabled
                              :value="jasper.filename"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="8">
              <b-form-group>
                <label>Percorso <required-field /></label>
                <b-form-input type="text" id="path" v-model="jasper.path" disabled
                              :value="jasper.path"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="12">
              <label for="jasperData">Sorgente Jasper Report <required-field /></label>
              <codemirror id="jasperData" v-model="jasperData" :options="cmOptions"></codemirror>
            </b-col>
          </b-row>
          <b-row class="dropzone m-1">
            <b-col sm="12">
              <div class="text-center p-3">
                <div v-if="$refs.upload && $refs.upload.dropActive" class="drop-active">
                  <h3>Rilascia il file per caricarlo</h3>
                </div>
                <h4>Trascina qui il file</h4>
                <vue-upload-component
                  class="btn btn-primary"
                  :multiple="false"
                  :drop="true"
                  :drop-directory="false"
                  @input-filter="inputFilter"
                  v-model="file"
                  ref="upload">
                  Seleziona il file
                </vue-upload-component>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle'
  // require component
  import {codemirror} from 'vue-codemirror'
  // require styles
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/xml/xml.js'
  import miniToastr from 'mini-toastr' //ES6
  import JasperService from "@/services/JasperService"
  import VueUploadComponent from 'vue-upload-component'
  import RequiredField from "../../components/RequiredField";

  const jasperService = JasperService.build();

  export default {
    name: 'JasperShow',
    props: {
      uri: {
        type: String,
        require: true
      }
    },
    components: {
      RequiredField,
      PageTitle,
      codemirror,
      VueUploadComponent
    },
    computed: {
      jasper: function () {
        return {
          uri: this.uri,
          filename: this.uri.substring(this.uri.lastIndexOf("/") + 1),
          path: this.uri.substring(this.uri.indexOf("/"), this.uri.lastIndexOf("/"))
        }

      }
    },
    data() {
      return {
        file: undefined,
        jasperData: '',
        jasperModels: [],
        cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'application/xml',
          lineWrapping: true,
          theme: 'default',
          opaque: true,
        }

      }
    },
    watch: {
      file: function (newFile, oldFile) {
        let _self = this;
        let reader = new FileReader();
        reader.onload = function () {
          let dataURL = reader.result;
          let buffer = _self.decode(dataURL);
          _self.jasperData = buffer.toString('ascii');
          miniToastr.success("Jasper caricato correttamente");

        };
        reader.readAsDataURL(newFile[0].file);
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      // fetch the data when the view is created and the data is
      // already being observed
      this.fetchData()
    },
    methods: {
      async fetchData() {
        let response = await jasperService.jrxml(this.jasper.uri);
        this.jasperData = response.data;
        this.jasperModels = await jasperService.models(this.jasper.uri)
      },
      async update() {
        if(!this.jasperData){
          miniToastr.error("Il sorgente del file è obbligatorio!");
        }else {
          try {
            await jasperService.updateJrxml(this.jasper.uri, this.jasperData)
            this.$router.push({name: 'jasperShowRoute', params: {uri: this.jasper.uri}})
            miniToastr.success("Jasper aggiornato con successo");
          } catch (exception) {
            miniToastr.error(exception.message);
          }
        }
      },
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          if (!/\.(xml|jrxml|txt)$/i.test(newFile.name)) {
            miniToastr.error('La tua scelta non è un xml/jrxml/txt')
            return prevent()
          }
        }
      },
      decode(uri) {

        //  dataurl    := "data:" [ mediatype ] [ ";base64" ] "," data
        //  mediatype  := [ type "/" subtype ] *( ";" parameter )
        //  data       := *urlchar
        //  parameter  := attribute "=" value

        let m = /^data:([^;,]+)?((?:;(?:[^;,]+))*?)(;base64)?,(.*)$/.exec(uri);
        if (!m) {
          throw new Error('Not a valid data URI: "' + truncate(uri, 20) + '"');
        }

        let media = '';
        let b64 = m[3];
        let body = m[4];
        let result = null;
        let charset = null;
        let mimetype = null;

        // If <mediatype> is omitted, it defaults to text/plain;charset=US-ASCII.
        // As a shorthand, "text/plain" can be omitted but the charset parameter
        // supplied.
        if (m[1]) {
          mimetype = m[1];
          media = mimetype + (m[2] || '');
        } else {
          mimetype = 'text/plain';
          if (m[2]) {
            media = mimetype + m[2];
          } else {
            charset = 'US-ASCII';
            media = 'text/plain;charset=US-ASCII';
          }
        }

        // The RFC doesn't say what the default encoding is if there is a mediatype
        // so we will return null.  For example, charset doesn't make sense for
        // binary types like image/png
        if (!charset && m[2]) {
          let cm = /;charset=([^;,]+)/.exec(m[2]);
          if (cm) {
            charset = cm[1];
          }
        }

        if (b64) {
          result = new Buffer(body, 'base64');
        } else {
          result = new Buffer(decodeURIComponent(body), 'ascii');
        }

        result.mimetype = mimetype;
        result.mediatype = media;
        result.charset = charset;

        return result;
      }
    }
  }
</script>
<style scoped>
  .dropzone {
    border: 1px solid lightgray;
    border-radius: 5px;
    background: #e4e7ea;
  }

  .dropzone .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }

  .dropzone .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
</style>
